export default "__VITE_ASSET__BVNomEJl__"